import { useMutation } from 'react-query';
import { httpService } from '../../../../../services/http.service';
import { BASE_URL } from '../../../../../constants/endpoints';
import { useStore } from '../../../../../store';

interface IProps {
    payload: {
        billId: string,
        supplierId: string,
        supplierName: string,
        documentId?: string,
        amount: number,
        dueDate: string,
        billNumber: string,
        paymentReminderData: {
            paymentReminderEnabled: boolean,
        },
        recurringPaymentData: {
            paymentFrequency: string,
            recurringNumber: number,
        }
    }
}

export const useCreateBill = ({ onSuccess }: {onSuccess?: () => void}) => {
  const { customerId } = useStore(state => state.user);
  const { accountExternalId } = useStore(state => state.getPersonalAccount());
  return useMutation(
    'CreateBill',
    async ({ payload }: IProps) => {
      const res = await httpService.post(`${BASE_URL}/api/v1/user/${customerId}/${accountExternalId}/bill`, { ...payload });
      return res.data;
    },
    {
      onSuccess: () => {
        if (onSuccess) onSuccess();
      },
    },
  );
};
